var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{directives:[{name:"scroll-lock",rawName:"v-scroll-lock",value:(true),expression:"true"}],staticClass:"loader"},[_c('div',{staticClass:"loader__spinner"}),(_vm.props.message)?_c('div',{staticClass:"loader__message"},[_vm._v(" "+_vm._s(_vm.props.message)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }